import React from "react";
import "./EmptyState.css";

/**
 * Generic empty-state block — reused by the feed today, and intended for
 * future sections (Communities, Challenges, Trending) per the design doc's
 * scalability notes.
 */
const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="empty-state">
    {Icon && (
      <div className="empty-state-icon">
        <Icon size={28} />
      </div>
    )}
    <h3 className="empty-state-title">{title}</h3>
    {description && <p className="empty-state-desc">{description}</p>}
    {action}
  </div>
);

export default EmptyState;
